/**
 * 将树结构的对象数组平铺成一级结构的对象数组
 * @param data 要转化的对象
 * @param childField 对象子集字段
 * @returns 一级结构数组
 */
export const treeToArr = (data: object, childField = "children") => {
  const result: any = [];
  const loop = (data: any) => {
    const { children, ...otherData } = data;
    result.push({
      ...otherData
    });
    let child = data[childField];
    if (child) {
      for (let i = 0; i < child.length; i++) {
        loop(child[i]);
      }
    }
  };
  loop(data);
  return result;
};

/**
 * 获取树结构的每一层级第一个对象
 * @param data 要转化的对象
 * @param childField 对象子集字段
 * @returns 每个层级的第一个对象值
 */
export const getTreeFirstValue = (data: object, childField = "children") => {
  let result: any = [];
  const loop = (data: any) => {
    const { childerList, ...otherData } = data;
    result.push({
      ...otherData
    });
    let child = data[childField];
    if (child) {
      loop(child[0]);
    }
  };
  loop(data);
  return result;
};


/**
 * @param {number} value 金额
 * @param {number} toFixed 保留的小数点位数(option)
 * @return {string} 保留小数点的金额
 */
export function floatNumberInThousands(value: any, toFixed = 2) {
  if ([null, undefined, '', false].includes(value)) {
    return '';
  }
  let valStr = '';
  if (['0', 0].includes(toFixed) || toFixed) {
    valStr = Number(value).toFixed(Number(toFixed));
  }

  const str = String(valStr);
  if (!~str.indexOf('.')) {
    return str.replace(/\B(?=(?:\d{3})+$)/g, ',');
  } else {
    let strArr = str.split('.');
    const integer = strArr[0].replace(/\B(?=(?:\d{3})+$)/g, ',');
    return `${integer}.${strArr[1]}`;
  }
}